import {isNull, CHECKER} from "../../util"

export default {
    data() {return {
        mx_filtered : [],
        mx_filter_forced : []
    }},
    methods : {
        // [METHOD] Outer filter
        mx_outerFilter(filter) {
            this.mx_syncFilter(filter);
            this.mx_buildData()
        },
        // [METHOD] Inject filter data to fields array
        mx_syncFilter(filter) {
            // 1. Reset previous
            this.mx_fieldsInfo.forEach((field) => {
                field.__filterValue = null;
            })
            // 2. normalize filter
            var arr = [];
            if(Array.isArray(filter)) {
                // 2.1 Array type argument
                filter.forEach(f=> { // f: {value:'', data:''}
                    // 2.1.1 prepare data;
                    var k = f.value, field = this.mx_fieldMap.get(k);
                    // 2.1.2 check valid
                    if(!field || isNull(f.data)) {return;}
                    // 2.1.3 Create & push filter
                    var checker = this.mx_filter_getChecker(field);
                    arr.push({value:k,data:f.data,checker});
                    // 2.1.4 Set value to filter(inward)
                    field.__filterValue = f.data;
                })
            } else if(typeof filter === 'object') {
                // 2.2 Object type argument
                for(var k in filter) {
                    // 2.2.1 prepare data
                    var field = this.mx_fieldMap.get(k);
                    // 2.2.2 check valid
                    if(!field || isNull(filter[k])) {continue;}
                    // 2.2.3 Create & push filter
                    var checker = this.mx_filter_getChecker(field);
                    arr.push({value:k,data :filter[k],checker});
                    // 2.2.4 Set value to filter(inward)
                    field.__filterValue = filter[k];
                }
            }
            // 3. set to grid's global filter
            this.mx_filtered=arr;
            return arr;
        },
        // [METHOD] It fire event, for grid consumer
        mx_filterData(arr) {
            // 1. filter array
            return arr.filter(row => {
                var rtn = true, fils = this.mx_filtered;
                for(var i=0, ii=fils.length; i<ii ; i++ ) {
                    var fi = fils[i];
                    
                    rtn = rtn && fi.checker(row[fi.value], fi.data, row);
                }
                return rtn;
            })
        },
        // [METHOD] build filter
        mx_buildFilter() {
            var arr = [];
            this.mx_fieldsInfo.forEach((f)=>{
                var fv = f.__filterValue;
                if(f.__isGroup >= 0 ) {
                    this.mx_filter_forced[f.__isGroup].data = fv;
                    return;
                }
                if(isNull(f.__filterValue)) {return}
                if(f.checker==='numberRange' && 
                        (!Array.isArray(fv) || fv.length !== 2 || (!fv[0] && !fv[1]))) {
                    return; // Just for performance
                }
                // 1. cacl checker
                var checker = this.mx_filter_getChecker(f);
                arr.push({value:f.value, data :fv, checker});
            });
            this.mx_filtered      = arr;
            return [
                ...(this.mx_filter_forced.filter(f=>!isNull(f.data))),
                ...arr];
        },
        mx_filter_getChecker(f) {
            // 1. For custom checker
            if(f.checker) {
                if(typeof f.checker === 'function') {
                    return f.checker
                } else if(CHECKER.hasOwnProperty(f.checker)) {
                    return CHECKER[f.checker];
                } else {
                    console.warn('[UIDev] Invalid checker for field "'+f.value+'".');
                }
            }
            // 2. Default checker via field type
            switch(f.type) {
            case 'number' : return CHECKER.number;
            case 'string' : return CHECKER.stringLike;
            case 'date'   : return CHECKER.date;
            case 'boolean': return CHECKER.boolean;
            case 'code':
                if(Array.isArray(f.domain)) {
                    return CHECKER.code
                } // else default
            default:
                return CHECKER.match;
            }
        }
    }
}
